/* eslint-disable no-unused-expressions */
import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Header } from "../components";
import { useInterestsContext } from "../contexts/InterestsContextProvider";
import { useAuthContext } from "../contexts/AuthContextProvider";
import { baseUrl } from "../apis/base_url";

const InterestCategoryView = () => {
  const { id } = useParams();
  const [interestCategory, setInterestCategory] = useState(null);
  const { allInterests, getAllInterests } = useInterestsContext();
  const { currentUser } = useAuthContext();

  const getInterests = useCallback(async () => {
    await getAllInterests(currentUser["token"]);
  }, [getAllInterests, currentUser]);

  const getCategoryInterests = useCallback(async () => {
    const interest = allInterests.find(
      (item) => item["id"].toString() === id.toString()
    );
    setInterestCategory(interest);
  }, [allInterests, id]);

  useEffect(() => {
    getInterests();
  }, [getInterests]);

  useEffect(() => {
    getCategoryInterests();
  }, [allInterests, getCategoryInterests]);

  return (
    <div className='pt-24 pb-10 bg-gray-100 md:py-10 '>
      {interestCategory ? (
        <div className='p-2 m-2 bg-white md:m-10 md:p-10 rounded-3xl'>
          <Header
            category='Interest Category'
            title={interestCategory && interestCategory["name"]}
          />
          {/* image */}
          {/* <div className="w-full mb-4">
            <div className="flex items-center justify-center gap-2">
              <img
                className="w-48 h-48 rounded-full"
                src={
                  interestCategory && baseUrl + "/" + interestCategory["icon"]
                }
                alt="employee"
              />
            </div>
          </div> */}

          {/* table */}
          <div className='flex flex-col'>
            <div className='overflow-x-auto'>
              <div className='p-1.5 w-full inline-block align-middle'>
                <div className='overflow-hidden border rounded-lg'>
                  <table className='min-w-full divide-y divide-gray-200'>
                    <tbody className='divide-y divide-gray-200'>
                      <tr>
                        <td className='px-6 py-4 text-sm font-medium text-gray-800 whitespace-nowrap'>
                          Name
                        </td>
                        <td className='px-6 py-4 text-sm text-gray-800 whitespace-nowrap'>
                          {interestCategory && interestCategory["name"]}
                        </td>
                      </tr>
                      <tr>
                        <td className='px-6 py-4 text-sm font-medium text-gray-800 whitespace-nowrap'>
                          Icon
                        </td>
                        <td className='px-6 py-4 text-sm text-gray-800 whitespace-nowrap'>
                          {interestCategory && (
                            <img
                              className='w-10 h-10'
                              src={baseUrl + "/" + interestCategory["icon"]}
                              alt='employee'
                            />
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td className='flex px-6 py-4 text-sm font-medium text-gray-800 whitespace-nowrap'>
                          SubInterests
                        </td>
                        <td className='px-6 py-4 text-sm text-gray-800 whitespace-nowrap'>
                          <ul className='gap-y-3 flex flex-col'>
                            {interestCategory &&
                              interestCategory["sub_interests"].map(
                                (item, index) => (
                                  <li key={index}>
                                    <div className='flex items-center gap-2'>
                                      <img
                                        className='w-10 h-10'
                                        src={baseUrl + "/" + item["icon"]}
                                        alt='employee'
                                      />
                                      <p>{item["name"]}</p>
                                    </div>
                                  </li>
                                )
                              )}
                          </ul>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className='p-2 m-2 bg-white md:m-10 md:p-10 rounded-3xl'>
          <h5 className='text-center font-bold text-md'>Loading ....</h5>
        </div>
      )}
    </div>
  );
};
export default InterestCategoryView;
